module.exports = __webpack_public_path__ + "img/landscape_1.a033a3dc.jpg";